// extracted by mini-css-extract-plugin
export default {"order-download-contents":"order-download-contents","orderDownloadContents":"order-download-contents"};